/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class CronService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param xCronSecret
     * @returns any Send push reminders to users missing today tips.
     * @throws ApiError
     */
    public cronControllerRemindUsersWithoutTodaysTips(
        xCronSecret?: string,
    ): CancelablePromise<{
        tournamentId?: number;
        timeZone?: string;
        from?: string;
        to?: string;
        matchCount?: number;
        userCount?: number;
        remindedUsers?: number;
        skippedUsers?: number;
        push?: {
            sent?: number;
            failed?: number;
            disabled?: number;
            errors?: Array<Record<string, any>>;
        };
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/cron/tips/today-reminder',
            headers: {
                'x-cron-secret': xCronSecret,
            },
        });
    }
    /**
     * @param xCronSecret
     * @returns any Send Czech push notifications about today top users and loser of the day.
     * @throws ApiError
     */
    public cronControllerNotifyDailyUserAwards(
        xCronSecret?: string,
    ): CancelablePromise<{
        tournamentId?: number;
        timeZone?: string;
        from?: string;
        to?: string;
        matchCount?: number;
        userCount?: number;
        topUsers?: Array<{
            id?: string;
            name?: string;
            points?: number;
        }>;
        loserUsers?: Array<{
            id?: string;
            name?: string;
            points?: number;
        }>;
        notificationsSent?: number;
        push?: {
            sent?: number;
            failed?: number;
            disabled?: number;
            errors?: Array<Record<string, any>>;
        };
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/cron/users/daily-awards',
            headers: {
                'x-cron-secret': xCronSecret,
            },
        });
    }
}
